export enum LogIdentifierType {
  DOCUMENT_UNDEFINEDDOCUMENTID = 'document.undefineddocumentid',
  AUTH_REFRESH_TOKEN = 'auth.refresh_token',
  AUTH_SESSION_MISMATCH = 'auth.session_mismatch'
}
